import { AsyncDropdown } from 'src/app/models/async-dropdown';

export class OrderUpdateModel {
  identifier: string;
  customer: AsyncDropdown;
  lob: AsyncDropdown;
  orderStatus: AsyncDropdown;
  owner: AsyncDropdown;
  pillar: AsyncDropdown;
  solution: AsyncDropdown;

  public constructor(init?: Partial<OrderUpdateModel>) {
    Object.assign(this, init);
  }
}
